import type { ModalActions } from 'src/components/ModalContainer';

interface UserModalActionsParams {
  submitLabel: string;
  loadingLabel: string;
  onSubmit: () => void;
  isSubmitting: boolean;
  isFormValid: boolean;
}

export const getUserModalActions = ({
  submitLabel,
  loadingLabel,
  onSubmit,
  isSubmitting,
  isFormValid,
}: UserModalActionsParams): ModalActions => [
  { label: 'Cancel', kind: 'secondary', testId: 'user-modal-cancel' },
  {
    label: submitLabel,
    kind: 'primary',
    onClick: onSubmit,
    disabled: !isFormValid,
    loading: isSubmitting,
    loadingLabel,
    testId: 'user-modal-submit',
  },
];
